import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { SerialControlOptions } from "../../../Interfaces/IFamilyGroupManagementFormField";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";

const Management: FC<DataTableType> = (props: DataTableType) => {
  const user = useSelector((state: any) => state.auth.user);

  const columnDefinition: IColumn[] = [
    {
      name: "Product Group",
      accessor: "ProductType",
    },
    {
      name: "Family Group",
      accessor: "FamilyGroup",
    },
    {
      name: "Family Group Description",
      accessor: "FamilyGroupDescription",
    },
    {
      name: "LP Family Group Mix",
      accessor: "LpFamilyGroupMix",
      type: "tick",
    },
    {
      name: "MLP Family Group Mix",
      accessor: "MlpFamilyGroupMix",
      type: "tick",
    },
    {
      name: "Serial Control",
      accessor: (rowData: any) => {
        return {
          value: rowData?.SerialControl
            ? SerialControlOptions.find(
                (x) => x.value === rowData?.SerialControl
              )?.label
            : "",
        };
      },
    },
    {
      name: "Serial Input Mask",
      accessor: "SerialInputMask",
    },
    {
      name: "Strap Totes",
      accessor: "StrapTotes",
      type: "tick",
    },
    {
      name: "Created Date",
      accessor: "CreatedDate",
    },
    {
      name: "Last Updated Date",
      accessor: "UpdatedDate",
    },
  ];

  if (user?.isLDMAdmin) {
    columnDefinition.push({
      name: "",
      accessor: "",
      type: "btn",
      btnType: "edit",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.getFamilyGroupData(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: false,
      isPaginationRequired: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default Management;
